<div class="app-multi-select">
  <div class="app-multi-select-item" *ngFor="let item of options">
      <input type="checkbox" [attr.option-value]="item.value"><label>{{item.label}}</label>
  </div>
</div>
